export default "__VITE_ASSET__BpKAHArS__"